import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_MONEY, MASK_NUMBER } from '../../../../theme/Component/BasicTable';
import { Modal } from '../../../../theme/Component/Modal';
import { _RawMaterialCatalogByRawMaterialRequest } from '../../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    idRawMaterialRequest: any;
    returnType?: "ID" | "Object";
    render?: string;
}

export const CatalogByRawMaterialRequestEditor = ({ idSelector, onChange, label, returnType = "ID", render, idRawMaterialRequest }: Props) => {

    const { instance, lista, setLista } = useDataBean(_RawMaterialCatalogByRawMaterialRequest)
    const [id, setID] = useState(null);

    const modal = useModal("Materia Prima", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idRawMaterialRequest])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDRawMaterial == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getRawMaterialCatalogByRawMaterialRequest(idRawMaterialRequest).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDRawMaterial', visible: true },
        { title: 'Nombre Materia Prima', property: 'Name', visible: true },
        { title: 'Código de Producto', property: 'StockKeepingUnit', visible: true },
        { title: 'ID Producto', property: 'IDProduct', visible: true },
        { title: 'Nombre de Producto', property: 'ProductName', visible: true, mask: MASK_NUMBER },
        { title: 'Unidad de Medida', property: 'UnitName', visible: true, mask: MASK_NUMBER },
        { title: 'Cantidad Total Requerida', property: 'TotalQuantity', visible: true, MASK: MASK_MONEY },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Materia Prima"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDRawMaterial); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}